import React from 'react'

interface IconProps {
  color: string
  className: string
}

function Comment({ className, color }: IconProps) {
  return (
    <svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.2386 10.0882C9.1126 11.0562 10.3556 11.5472 11.9346 11.5472C13.5086 11.5472 14.7616 11.0592 15.6586 10.0962C16.8936 8.7702 17.0116 6.9322 17.0096 6.2682C17.0096 6.1272 16.8946 6.0192 16.7536 6.0192H15.2646C15.1246 6.0192 15.0126 6.1262 15.0096 6.2652C14.9976 6.7802 14.8896 7.9862 14.1946 8.7332C13.6846 9.2812 12.9456 9.5472 11.9346 9.5472C10.9366 9.5472 10.2156 9.2882 9.7306 8.7552C9.0626 8.0222 8.9886 6.7992 8.9906 6.2732C8.9906 6.1302 8.8766 6.0192 8.7346 6.0192H7.2486C7.1106 6.0192 6.9976 6.1222 6.9936 6.2602C6.9716 6.9152 7.0296 8.7482 8.2386 10.0882Z" fill={color}/>
      <path fillRule="evenodd" clipRule="evenodd" d="M2.997 0H21.003C22.658 0 24 1.342 24 2.997V14.003C24 15.658 22.658 17 21.003 17H12L6.427 22.987C6.27 23.143 6 23.033 6 22.809V17H2.997C1.342 17 0 15.658 0 14.003V2.997C0 1.342 1.342 0 2.997 0ZM20.995 15C21.55 15 22 14.55 22 13.995V3.005C22 2.45 21.55 2 20.995 2H3.005C2.45 2 2 2.45 2 3.005V13.995C2 14.55 2.45 15 3.005 15H8V18L11 15H20.995Z" fill={color}/>
    </svg>
  )
}

export default Comment
